// TODO: use monorepo to extract utils package to share between Madrid with other projects
// Also extract stringResources and globalVariables
/**
 * Whether the expression is a logic app expression.
 * If it's a pure plain text, return false
 * Otherwise, return true, even if it's a plain text with escaped characters or it's invalid for LogicApp
 */
 export function isLogicAppExpression(expression: string): boolean {
  if (!expression || typeof expression !== 'string') {
      return false;
  }

  // Single '@' means '@'
  if (expression === '@') {
      return false;
  }
  // Start with @, not start with @@ or @{, it's a pure expression
  if (expression.indexOf('@') === 0 && !(expression.indexOf('@@') === 0 || expression.indexOf('@{') === 0)) {
      return true;
  }
  // Start with N "@" (N > 1), it's treated as N-1 "@", escape charactor is still logic for LogicApp, will treat it as an expression
  // Contains "@{""
  //   If not "@@{", it's partially an expression
  //   If "@@{", escape charactor is still logic for LogicApp, will treat it as an expression
  if (expression.indexOf('@@') === 0 || expression.indexOf('@{') >= 0) {
      return true;
  }
  return false;
}
